import { Component, Input } from "@angular/core";
import { MessageSenderHttpService } from "app/common/send-message-dialog/http-service/message-sender.http.service";
import { PDFDocument } from "pdf-lib";
import * as FileSaver from "file-saver";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { SnackbarConfig } from "app/common";
import { State } from "app/reducers";
import { SHOW_SNACKBAR } from "app/reducers/actions/snackbar";
import { StatementService } from "app/statements/statement.service";
import { DeviceRecognizerHelper } from "app/core/helpers/device-recognizer.helper";
import { MobileDownloadFileHelper } from "app/core/helpers/mobile-apps/mobile-download-file.helper";

export interface FileData {
  isValidated: boolean;
  file: File;
}

export interface SendedFileData {
  file: string;
  id: number;
  message_id: number;
  statement: number;
}

@Component({
    selector: "app-add-attachment-list",
    templateUrl: "./add-attachment-list.component.html",
    styleUrls: ["./add-attachment-list.component.scss"],
    standalone: false
})
export class AddAttachmentListComponent {
  @Input() attachmentsList: Array<FileData> = [];
  @Input() buttonText = "";
  @Input() maxFilesNumber = 2;
  @Input() sendedAttachments: Array<SendedFileData> = [];

  public maxFilesNumberError = false;

  constructor(
    public messageSenderHttpService: MessageSenderHttpService,
    private statementService: StatementService,
    private store: Store<State>
  ) {}

  public handleDownloadSendedAttachment(attachment: SendedFileData): void {
    const isMobile = DeviceRecognizerHelper.isAndroidWebview() || DeviceRecognizerHelper.isIosWebview();

    if (isMobile) {
      const downloadObservable: Observable<any> = this.statementService.downloadDecisionPDF(
        attachment.statement,
        "message_document",
        attachment.id
      );

      MobileDownloadFileHelper.handleMobileObservableResponse(downloadObservable, this.showPDFError.bind(this));
    } else {
      this.statementService
        .downloadDecisionPDF_desktop(attachment.statement, "message_document", attachment.id)
        .subscribe({
          next: (res: Blob) => FileSaver.saveAs(res, attachment.file),
          error: (error: any) => {
            console.error(error);
            this.showPDFError();
          }
        });
    }
  }

  private showPDFError(): void {
    this.store.dispatch({ type: SHOW_SNACKBAR, payload: new SnackbarConfig("SNACKBAR.PDF_NOT_AVAILABLE", "ERROR") });
  }

  public async validateFile(file: File): Promise<FileData> {
    const fileObject: FileData = {
      isValidated: true,
      file: file
    };

    if (file.type !== "application/pdf") {
      fileObject.isValidated = false;
      return fileObject;
    }

    if (file.size / (1024 * 1024) > 10) {
      fileObject.isValidated = false;
      return fileObject;
    }

    try {
      const pdfBytes = await file.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes);
      const pageCount = pdfDoc.getPageCount();

      if (pageCount > 100 || pageCount === 0) {
        fileObject.isValidated = false;
        return fileObject;
      }
    } catch (error) {
      console.log("Błąd podczas odczytu liczby stron");
      console.error(error);
      fileObject.isValidated = false;
      return fileObject;
    }

    return fileObject;
  }

  public async handleAddAttachment(event: Event): Promise<void> {
    const input = event.target as HTMLInputElement;

    if (!input.files) return;

    const files = Array.from(input.files);

    if (this.checkAttachmentsListLength(files)) {
      this.maxFilesNumberError = false;
      const results = await Promise.all(files.map((file) => this.validateFile(file)));
      results.forEach((fileObject) => this.attachmentsList.push(fileObject));
    } else {
      this.maxFilesNumberError = true;
    }
  }

  private checkAttachmentsListLength(files: File[]): boolean {
    console.log(this.sendedAttachments);

    return this.attachmentsList.length + files.length + this.sendedAttachments.length <= this.maxFilesNumber;
  }

  public handleRemoveAttachment(index: number): void {
    this.attachmentsList.splice(index, 1);
  }

  public handleRemoveSendedAttachment(index: number): void {
    const { statement, id, message_id } = this.sendedAttachments[index];

    this.messageSenderHttpService.removeMessageAttachment(statement, message_id, id).subscribe(
      (response) => {
        console.log("success");
        this.sendedAttachments.splice(index, 1);
      },
      (error) => {
        console.log(error);
      }
    );
  }
}
